import { types } from 'mobx-state-tree';

const Errors = types.model({
  saving: false,
});

export default Errors;
